import { getCountry } from '../modules/i18n';

type CountryCondition = { country: string; content: string };

function getCountryConditions(element: HTMLElement): CountryCondition[] | null {
  // Elements rendered by jb-form have countryCondition set as a JS property via init()
  const prop = (element as HTMLElement & { countryCondition?: unknown }).countryCondition;
  if (Array.isArray(prop) && prop.length > 0) return prop as CountryCondition[];

  // Server-rendered elements (Fluid template) have it as an HTML attribute
  const attr = element.getAttribute('countrycondition');
  if (!attr) return null;
  try {
    return JSON.parse(attr) as CountryCondition[];
  } catch {
    return null;
  }
}

function applyCountryCondition(element: HTMLElement, currentCountry: string): void {
  const conditions = getCountryConditions(element);
  if (!conditions) return;

  const match = conditions.find((c) => c.country.toLowerCase() === currentCountry.toLowerCase());

  if (match) {
    (element as HTMLElement & { content: string }).content = match.content;
    element.style.display = '';
  } else {
    element.style.display = 'none';
  }
}

window.addEventListener('DOMContentLoaded', async () => {
  const currentCountry = await getCountry();

  document.querySelectorAll<HTMLElement>('jb-info-box').forEach((element) => {
    applyCountryCondition(element, currentCountry);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.tagName === 'JB-INFO-BOX') {
          applyCountryCondition(node, currentCountry);
        }

        node.querySelectorAll<HTMLElement>('jb-info-box').forEach((el) => {
          applyCountryCondition(el, currentCountry);
        });
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // jb-form may render jb-info-box inside a shadow tree (e.g. contact overlay),
  // where the document-level MutationObserver above doesn't reach.
  document.addEventListener('jb-form:ready', (event) => {
    const form = event.composedPath()[0] as HTMLElement | undefined;
    if (!form) return;
    form.querySelectorAll<HTMLElement>('jb-info-box').forEach((el) => {
      applyCountryCondition(el, currentCountry);
    });
  });
});
